export function notEmpty(value) {
  return value.trim().length !== 0
}

export function isValidEmail(val) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(val).toLowerCase())
}

export function checkPassword(value) {
  return value.length > 11
}
